import React from 'react'

import { Div } from '@driftt/tide-core'

import styles from './styles.module.css'

const Toast: React.FC<{
  text: string
}> = ({ text }) => {
  return <Div className={styles.Toast}>{text}</Div>
}

export default Toast
